import axios from "axios";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { PdsrEditItem } from "../PdsrEditItem";
import { namedQueryKeyWithId } from "../../../../ReactQuery/namedQueryKeyWithId";
import { objectWithIdNotFoundMessage } from "../../../../Messages/errorMessages";
import { pdsrUrls } from "../../../../URL/ApplicationUrls";

export const useFetchPdsr = (pdsrId: string | undefined) => {
  return useQuery<PdsrEditItem, Error>({
    queryKey: namedQueryKeyWithId("pdsrs", pdsrId),
    queryFn: () => fetchPdsr(pdsrId),
    onError: () => {
      toast.error(objectWithIdNotFoundMessage(pdsrId, "Pdsr"));
    },
  });
};

const fetchPdsr = async (id: string | undefined) => {
  const { data: pdsr } = await axios.get<PdsrEditItem>(pdsrUrls.pdsrWithId(id));
  return pdsr;
};
